export async function CitaUpdate(
    citaResp, citaTipo, citaPac, citaFecha, citaHora, citaFinFecha, citaFinHora, citaObs, pacienteId,
    citaId, citaEsp ) {
        console.log(citaId);
    const formData = {
        title: `us-${pacienteId}-cita-${citaFecha}`,
        slug: `us-${pacienteId}-cita-${citaFecha}`,
        status: "publish",
        meta: {
            citaResp: citaResp,
            citaTipo: citaTipo,
            citaPac: citaPac,
            citaEsp: citaEsp,
            citaPacId: pacienteId,
            citaFecha: citaFecha,
            citaHora: citaHora,
            citaFinFecha: citaFinFecha,
            citaFinHora: citaFinHora,
            citaObs: citaObs,
        }
    };

	const authToken = sessionStorage.getItem( 'token' );

        try {
            const response = await fetch(`https://app.tavad.com/hce/wp-json/wp/v2/cita/${citaId}`, {
                method: 'POST',
                headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${ authToken }`,
                
                },
                body: JSON.stringify(formData),
            } );
            const values = await response.json();
            console.log(values);
            return values;
        } catch (error) {
            console.error(error);
        }

}


export async function CitaUpdateAsociaciones(    
    citaId, citaPostId, citaNotificacionId) {
    const formData = {
        meta: {
            citaPostId: citaPostId,
            citaNotificacionId: citaNotificacionId,
        }
    };

	const authToken = sessionStorage.getItem( 'token' );

        try {
            const response = await fetch(`https://app.tavad.com/hce/wp-json/wp/v2/cita/${citaId}`, {
                method: 'POST',
                headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${ authToken }`,
                
                },
                body: JSON.stringify(formData),
            } );
            const values = await response.json();
            console.log(values);
            return values;
        } catch (error) {
            console.error(error);
        }

}